/* eslint-disable react/style-prop-object */
import { useContext, useEffect, useState } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import Close from "../../Helpers/CloseBtn/Close";
import Loader from "../../Helpers/Loader/Loader";
import { useGetSingleIRQuery } from "../../../Redux/service/IR/IR";
import Popup from "../../Helpers/Popup/Popup";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import { Modal } from "react-bootstrap";
import { Segmented, Tag } from "antd";

import {
	StepBackwardOutlined,
	LeftOutlined,
	RightOutlined,
	StepForwardOutlined,
} from "@ant-design/icons";
import trans from "../../../utils";
import InspectionRequestInformation from "./InspectionRequestInformation";
import InspectionRequestDeficiency from "./InspectionRequestDeficiency";
import { useSelector } from "react-redux";
import InspectonRequestPopupAction from "./InspectonRequestPopupAction";
import InspectionRequestRevisions from "./InspectionRequestRevisions";
import InspectionRequestFormSubmission from "./InspectionRequestFormSubmission";
import InspectionRequestQAResubmit from "./InspectionRequestQAResubmit";
import { useGetSpecificFormQuery } from "../../../Redux/service/Forms/Form";
import Button from "../../Helpers/Button/Button";
import useIsMobile from "../../../hooks/useIsMobile";

export function InspectonRequestPopup({ irId }) {
	const isMobile = useIsMobile();
	let { setcurrentIRId, edited } = useContext(popupcontext);
	let { data, isLoading, refetch } = useGetSingleIRQuery(irId, {
		skip: !irId,
		refetchOnMountOrArgChange: true,
	});
	const inf = useSelector((state) => state.users.user);
	const OfflineMode = useSelector((state) => state.users.offlineMode);
	const [resubmit, setResubmit] = useState(false);
	const [qaAction, setQAAction] = useState(false);
	const [activeOption, setActiveOption] = useState("information");
	const [currentRevisionIndex, setCurrentRevisionIndex] = useState(null);
	const [showResubmitPopup, setShowResubmitPopup] = useState(false);
	const [showQAResubmitPopup, setShowQAResubmitPopup] = useState(false);
	const closeuser = () => {
		setcurrentIRId(null);
	};
	useEffect(() => {
		if (edited) {
			refetch();
		}
	}, [edited, refetch]);

	// Initialize revision index when data loads and Revisions segment is active
	useEffect(() => {
		if (
			activeOption === "Revisions" &&
			data?.data?.revisions?.length > 0 &&
			currentRevisionIndex === null
		) {
			setCurrentRevisionIndex(data.data.revisions.length - 1);
		}
	}, [activeOption, data?.data?.revisions, currentRevisionIndex]);
	const statusColors = {
		CLOSED: `blue`,
		PENDING_QA: `orange`,
		PENDING_CONSULTANT: `orange`,
		QA_APPROVED: `green`,
		CONSULTANT_APPROVED: `green`,
		QA_REJECTED: `red`,
		CONSULTANT_REJECTED: `red`,
		CONSULTANT_APPROVED_WITH_COMMENTS: `purple`,
		DRAFT: `default`,
		CANCELLED: `default`,
	};

	const activeRevisions =
		activeOption === "iirRevisions"
			? data?.data?.revisionTracking?.iirRevisions
			: activeOption === "eirRevisions"
				? data?.data?.revisionTracking?.eirRevisions
				: null;

	const segments = [
		{
			label: isMobile ? trans("Info") : trans("information"),
			value: "information",
		},
		{
			label: isMobile ? trans("Workflow") : trans("Workflow & Actions"),
			value: "deficiency",
		},
		{
			label: `${trans("IIR")} (${
				data?.data?.revisionTracking?.iirRevisions?.length || 0
			})`,
			value: "iirRevisions",
		},
		{
			label: `${trans("EIR")} (${
				data?.data?.revisionTracking?.eirRevisions?.length || 0
			})`,
			value: "eirRevisions",
		},
	];

	const visibleSegments =
		inf?.attributes?.role === "consultant"
			? segments.filter((seg) => seg.value !== "iirRevisions")
			: segments;

	// Get form fields for resubmit popup
	const { data: formFields } = useGetSpecificFormQuery(
		data?.data?.form?.id || data?.data?.form_id,
		{
			skip:
				(!data?.data?.form?.id && !data?.data?.form_id) || !showResubmitPopup,
			refetchOnMountOrArgChange: true,
		},
	);

	// Convert current form data to the format expected by InspectionRequestFormSubmission
	const getCurrentFormData = () => {
		if (
			!data?.data?.form_data_snapshot ||
			!formFields?.data?.formSchema?.fields
		) {
			return [];
		}

		const snapshot = data.data.form_data_snapshot;
		const fields = formFields.data.formSchema.fields;

		const flattenFields = (fields) => {
			return fields.flatMap((field) => {
				if (field.name === "Container" && Array.isArray(field.container)) {
					return [field, ...flattenFields(field.container)];
				}
				return field;
			});
		};

		const allFields = flattenFields(fields);

		return allFields.map((field) => {
			const snapshotItem = snapshot.find(
				(item) =>
					item.key === field.key ||
					item.name === field.name ||
					item.title === field.title ||
					(field.label && item.title === field.label) ||
					(field.label && item.name === field.label),
			);

			return {
				key: field.key,
				value: snapshotItem?.value || field.defaultValue || null,
			};
		});
	};

	const formDataValues = showResubmitPopup ? getCurrentFormData() : [];
	console.log("CHECK", !!irId && !OfflineMode);
	return (
		<Popup show={!!irId && !OfflineMode} size="lg">
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle
						headtitle={`${data?.data?.ir_number && data?.data?.ir_number}`}
						subtitle={
							<Tag color={statusColors[data?.data?.status] || "default"}>
								{trans(data?.data?.status)}
							</Tag>
						}
					/>
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={closeuser}
					img="Close"
				/>
			</Modal.Header>
			<Segmented
				options={visibleSegments}
				style={{ textTransform: "capitalize" }}
				onChange={(value) => {
					setActiveOption(value);
					setResubmit(false);
					// Reset to last revision when switching to Revisions segment
					if (
						value === "iirRevisions" &&
						data?.data?.revisionTracking?.iirRevisions?.length > 0
					) {
						setCurrentRevisionIndex(
							data.data.revisionTracking.iirRevisions.length - 1,
						);
					} else if (
						value === "eirRevisions" &&
						data?.data?.revisionTracking?.eirRevisions?.length > 0
					) {
						setCurrentRevisionIndex(
							data.data.revisionTracking.eirRevisions.length - 1,
						);
					} else {
						setCurrentRevisionIndex(null);
					}
				}}
				value={activeOption}
				size={isMobile ? "middle" : "large"}
				block
			/>
			<Modal.Body className="modal-body-scrollable fixed-popup-height">
				{isLoading ? (
					<div className="loader-container">
						<Loader />
					</div>
				) : (
					<>
						{activeOption === "information" && (
							<InspectionRequestInformation
								values={data?.data}
								statusColors={statusColors}
							/>
						)}
						{activeOption === "deficiency" && (
							<>
								<InspectionRequestDeficiency
									values={data?.data?.deficiencies}
									approvalHistory={data?.data?.approvalWorkflows}
									status={data?.data?.status}
									setActiveOption={setActiveOption}
									resubmit={resubmit}
									setResubmit={setResubmit}
									setQAAction={setQAAction}
									role={inf.attributes.role}
									refetch={refetch}
									onResubmitClick={() => setShowResubmitPopup(true)}
									onQAResubmitClick={() => setShowQAResubmitPopup(true)}
								/>

								{/* {inf.attributes.role === "qa" && (
									<>
										{data?.data?.status === "PENDING_QA" ||
										data?.data?.status === "PENDING_CONSULTANT" ||
										data?.data?.status === "CONSULTANT_REJECTED" ||
										data?.data?.status === "QA_REJECTED" ? (
											qaAction || data?.data?.deficiencies?.length === 0 ? (
												<InspectionRequestQA
													setQAAction={setQAAction}
													deficienciesLen={data?.data?.deficiencies?.length}
												/>
											) : (
												<InspectionRequestDeficiency
													values={data?.data?.deficiencies}
													approvalHistory={data?.data?.approvalWorkflows}
													status={data?.data?.status}
													setActiveOption={setActiveOption}
													qaAction={qaAction}
													setQAAction={setQAAction}
													role="qa"
												/>
											)
										) : (
											<div className="text-center text-muted py-4">
												{trans("Add deficiency only in QA process")}
											</div>
										)}
									</>
								)}

								{inf.attributes.role === "consultant" && (
									<>
										{data?.data?.status === "PENDING_CONSULTANT" ||
										data?.data?.status === "PENDING_QA" ||
										data?.data?.status === "QA_REJECTED" ||
										data?.data?.status === "CONSULTANT_REJECTED" ? (
											qaAction ||
											(data?.data?.deficiencies?.length === 0 &&
												data?.data?.status === "PENDING_CONSULTANT") ? (
												<InspectionRequestConsultantQA />
											) : (
												<InspectionRequestDeficiency
													values={data?.data?.deficiencies}
													approvalHistory={data?.data?.approvalWorkflows}
													status={data?.data?.status}
													setActiveOption={setActiveOption}
													qaAction={qaAction}
													setQAAction={setQAAction}
													role="consultant"
												/>
											)
										) : (
											<div className="text-center text-muted py-4">
												{trans("Add comments only in Consultant QA process")}
											</div>
										)}
									</>
								)} */}

								<InspectonRequestPopupAction
									deficienciesLen={data?.data?.deficiencies?.length}
									qaAction={qaAction}
									setQAAction={setQAAction}
									refetch={refetch}
								/>
							</>
						)}
						{activeRevisions && (
							<InspectionRequestRevisions
								refetch={refetch}
								allData={data?.data}
								data={activeRevisions}
								currentRevisionIndex={currentRevisionIndex}
							/>
						)}
					</>
				)}
			</Modal.Body>
			{activeRevisions &&
				activeRevisions?.length > 0 &&
				currentRevisionIndex !== null && (
					<Modal.Footer>
						<div className="d-flex justify-content-between align-items-center w-100">
							<div className="d-flex gap-2">
								<Button
									icon={<StepBackwardOutlined />}
									onClick={() => setCurrentRevisionIndex(0)}
									disabled={currentRevisionIndex === 0}
									type="default"
								>
									{!isMobile && trans("First")}
								</Button>
								<Button
									icon={<LeftOutlined />}
									onClick={() => {
										if (currentRevisionIndex > 0) {
											setCurrentRevisionIndex(currentRevisionIndex - 1);
										}
									}}
									disabled={currentRevisionIndex === 0}
									type="default"
								>
									{!isMobile && trans("Previous")}
								</Button>
							</div>
							<div className="text-muted">
								{!isMobile && trans("Revision")} {currentRevisionIndex + 1}{" "}
								{trans("of")} {activeRevisions.length}
							</div>
							<div className="d-flex gap-2">
								<Button
									icon={<RightOutlined />}
									onClick={() => {
										if (currentRevisionIndex < activeRevisions.length - 1) {
											setCurrentRevisionIndex(currentRevisionIndex + 1);
										}
									}}
									disabled={currentRevisionIndex === activeRevisions.length - 1}
									type="default"
								>
									{!isMobile && trans("Next")}
								</Button>
								<Button
									icon={<StepForwardOutlined />}
									onClick={() =>
										setCurrentRevisionIndex(activeRevisions.length - 1)
									}
									disabled={currentRevisionIndex === activeRevisions.length - 1}
									type="default"
								>
									{!isMobile && trans("Last")}
								</Button>
							</div>
						</div>
					</Modal.Footer>
				)}
			{/* Resubmit Form Popup */}
			<Popup show={showResubmitPopup} size="lg">
				<Modal.Header className="modal-header flex-between">
					<Modal.Title id="contained-modal-title-vcenter">
						<PopupTitle
							headtitle={trans("Resubmit Form")}
							subtitle={<Tag color="orange">{data?.data?.ir_number || ""}</Tag>}
						/>
					</Modal.Title>
					<Close
						style="close-32 close"
						close={() => setShowResubmitPopup(false)}
						img="Close"
					/>
				</Modal.Header>
				<Modal.Body className="modal-body-scrollable fixed-popup-height">
					{formFields?.data?.formSchema?.fields ? (
						<InspectionRequestFormSubmission
							values={formDataValues}
							formFields={formFields?.data?.formSchema?.fields}
							resubmit={true}
							setResubmit={setResubmit}
							setActiveOption={() => {}}
							irId={irId}
							refetch={() => {
								refetch();
								setShowResubmitPopup(false);
							}}
							formRefetch={() => {}}
							onSuccess={() => {
								refetch();
								setShowResubmitPopup(false);
							}}
						/>
					) : (
						<div className="text-center py-4">
							<Loader />
						</div>
					)}
				</Modal.Body>
			</Popup>
			{/* QA Resubmit Form Popup */}
			<Popup show={showQAResubmitPopup} size="lg">
				<Modal.Header className="modal-header flex-between">
					<Modal.Title id="contained-modal-title-vcenter">
						<PopupTitle
							headtitle={trans("QA Resubmit Form")}
							subtitle={<Tag color="orange">{data?.data?.ir_number || ""}</Tag>}
						/>
					</Modal.Title>
					<Close
						style="close-32 close"
						close={() => setShowQAResubmitPopup(false)}
						img="Close"
					/>
				</Modal.Header>
				<Modal.Body className="modal-body-scrollable fixed-popup-height">
					<InspectionRequestQAResubmit
						irId={irId}
						onSuccess={() => {
							refetch();
							setShowQAResubmitPopup(false);
						}}
					/>
				</Modal.Body>
			</Popup>
		</Popup>
	);
}
